module.exports = __webpack_public_path__ + "static/media/circle-1.8574577e.svg";